import React, { useRef, useState, useEffect } from "react";
import {Navbar, Button } from 'flowbite-react';
import { HiArrowLeft } from "react-icons/hi2";
import { FaCamera } from "react-icons/fa";
import { BsThreeDots } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { handleLoadVehicleLog, handleCarInsuranceClick, handleFileChange, validateOnUpdate, handleSubmitDocument } from "./handler";
import logdetails from "../../../img/insurance.png";
import { MdCheckCircle } from "react-icons/md";

const CarInsuranceComponents = (props) => {
    const selectedProfileType = JSON.parse(sessionStorage.getItem("selectedProfileType"));

    const cssForImageCard = {
        success: {
          imageDiv:
            "mt-2 mb-10 custom-card-success border rounded-md items-center shadow-none p-10",
        },
        standard: {
          imageDiv:
            "mt-2 mb-10 custom-card border rounded-md items-center shadow-none p-10",
        },
    };

    const vehicleLogRef = useRef(null);

    const [carInsurancePicture, setCarInsurancePicture] = useState("")
    let [validation, setValidation] = useState(false);
    const [carInsuranceDetails, setCarInsuranceDetails] = useState({
        carInsuranceCompany: "",
        carInsuranceExpiryDate: "",
    })
    let [userUploadedInsurancePic, setUserUploadedInsurancePic] = useState(false);
    let [insuranceLoading, setInsuranceLoading] = useState(false);
    let [validationOnSubmit, setValidationOnSubmit] = useState({
        show: false,
        message: "",
        class: "",
    });
    const navigate = useNavigate();

    useEffect(() => {
        handleLoadVehicleLog(props.itemIndex, props.memberRequirement.requiredDocuments, setCarInsuranceDetails, setCarInsurancePicture, logdetails, setUserUploadedInsurancePic)
    } , [])

    return (
        <>
            <Navbar
                fluid={true}
                rounded={true}
                className='shadow mb-3' style={{position:'fixed', width:'100%', top:'0'}}
            >  
                <Navbar.Brand onClick={()=>{props.setOpenUploadDocument({openDocument : false , documentType : ""})}}>
                  <HiArrowLeft className='h-10 w-5 ml-2' />
                </Navbar.Brand>
            </Navbar>
            <div className='p-6  max-w-md m-auto' style={{paddingTop:'80px'}}>
                <h5 className="text-2xl mb-2 font-bold tracking-tight text-gray-900 dark:text-white">Car Insurance</h5>
                {
                    validationOnSubmit.show && (
                        <div className={validationOnSubmit.class}>
                          <span>{validationOnSubmit.message}</span>
                        </div>
                      )
                }

                {
                    userUploadedInsurancePic && (
                        <div
                            class="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white"
                            style={{ paddingRight: "10px" }}
                        >
                            <MdCheckCircle style={{ color: "#15BE44" }} />
                        </div>
                    )
                }

                <label className='font-bold tracking-tight text-gray-900'>Details</label>
                <div 
                    className={
                        userUploadedInsurancePic
                            ? cssForImageCard.success.imageDiv
                            : cssForImageCard.standard.imageDiv
                        }
                >
                {
                    validation && (
                        <div className="error-msg">
                          <span>Invalid image. Only images of type png, jpg, jpeg with size
                below 7mb can be uploaded</span>
                        </div>
                      )
                }
                    <img src={carInsurancePicture}
                         className="w-auto m-auto"
                         alt="Ryde" />
                    <p className='text-xs text-gray-400 tracking-tight mt-2'><i>Ensure photo is clear with all four sides visible </i></p>
                    <Button  pill={true} className='mt-5 m-auto w-sm pr-4'onClick={(e) => {e.preventDefault(); handleCarInsuranceClick(vehicleLogRef);}}> 
                    {
                        insuranceLoading ? (
                            <BsThreeDots className="h-5 w-10" />
                        ) : (
                            <FaCamera className="h-5 w-10" />
                        )
                    }
                    <label className="relative cursor-pointer rounded-md font-medium">
                      <span>
                      {
                        insuranceLoading
                            ? "Saving"
                            : userUploadedInsurancePic
                            ? "Replace"
                            : "Upload"
                     }
                      </span>
                    </label> 
                    </Button>
                    <input 
                        id="file-upload" 
                        name="file-upload"
                        type="file"
                        ref={vehicleLogRef}
                        style={{display: 'none', width:'0px'}}
                        onChange={async (event)=>{
                            await handleFileChange(event, "carInsurance",setValidation, setInsuranceLoading, setCarInsurancePicture,
                            setUserUploadedInsurancePic, props.memberRequirement, props.setMemberRequirement,props.itemIndex, navigate,selectedProfileType)
                            // validateOnUpdate(validationOnSubmit, carInsuranceDetails, setValidationOnSubmit, userUploadedInsurancePic)
                        }}
                    />
                </div>

                <div className="col-span-6 mb-8">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                        Insurance Company
                    </label>
                    <input
                        type="text"
                        name="contact-number"
                        placeholder=''
                        id=""
                        autoComplete=""
                        value={carInsuranceDetails.carInsuranceCompany}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                        onChange={(e) => { 
                            setCarInsuranceDetails(details=> ({...details, carInsuranceCompany: e.target.value}));
                           // validateOnUpdate(validationOnSubmit, carInsuranceDetails, setValidationOnSubmit, userUploadedInsurancePic);
                        }  
                        }
                     />
                </div>

                <div className="col-span-6">
                    <label
                        htmlFor="name"
                        className="block text-sm font-medium text-gray-700"
                    >
                        Insurance Expiry Date
                    </label>
                    <input
                        type="date"
                        name="name"
                        id="name"
                        autoComplete="name"
                        value={carInsuranceDetails.carInsuranceExpiryDate}
                        onChange={(e) => { 
                            setCarInsuranceDetails(details=> ({...details, carInsuranceExpiryDate: e.target.value}));
                           // validateOnUpdate(validationOnSubmit, carInsuranceDetails, setValidationOnSubmit, userUploadedInsurancePic);
                        }}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    />
                    <span className="block text-sm font-medium text-gray-700">
                    <i>
                    * Please ensure your insurance expiry has a 1 year validity
                    period.
                    </i>
                    </span>
                </div>

                <Button className='bg-primary w-full mt-5' pill={true} disabled={false} onClick={(e) => {
                    e.preventDefault();
                    let validitForm = validateOnUpdate(validationOnSubmit, carInsuranceDetails, setValidationOnSubmit, userUploadedInsurancePic);
                    if (validitForm) {
                        handleSubmitDocument(carInsuranceDetails, selectedProfileType.profileId, props.memberRequirement, props.setMemberRequirement, props.itemIndex, props.setOpenUploadDocument, navigate)
                        return
                    } 
                    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
                    }
                }
                        // onClick={()=>{
                        // if(userUploadedLogPic ) {
                        //     props.setOpenUploadDocument({
                        //       openDocument: false,
                        //       documentType: "",
                        //     });
                        //   } else {
                        //     setValidationOnSubmit(true)
                        //     window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
                        //   }
                        // }}
                >
                    Save
                  </Button>





            </div>
        </>
    )
}

export default CarInsuranceComponents;